import { actionTypes } from './actions'
import { Map } from 'immutable'
import { dataModels } from '../../dataModels'

const { getInitialPromoFilter, getInitialNotificationFilter } = dataModels

const initialState = Map({
    promotion_filters: getInitialPromoFilter(),
    notification_filters: getInitialNotificationFilter(),
})

const filterReducer = (state = initialState, action) => {
    const { type, payload } = action

    switch (type) {
        case actionTypes.UPDATE_PROMOTION_FILTERS: {
            return state.merge({
                promotion_filters: payload,
            })
        }

        case actionTypes.CLEAR_ALL_FILTERS: {
            return state.merge({
                promotion_filters: getInitialPromoFilter(),
            })
        }

        case actionTypes.UPDATE_NOTIFICATION_FILTERS: {
            return state.merge({
                notification_filters: payload,
            })
        }

        case actionTypes.CLEAR_ALL_NOTIFICATION_FILTERS: {
            return state.merge({
                notification_filters: getInitialNotificationFilter(),
            })
        }

        default:
            return state
    }
}

export default filterReducer
